import { Icon, Popover } from '@main/core-ui';
import React from 'react';

import { SanitizeHtml } from '../../SanitizeHtml';

export interface DescriptionProps {
  /** Id to use for popover */
  id?: string;
  /** The description HTML message */
  descriptionHtml: string;
}

export const Description: React.FC<DescriptionProps> = ({
  id,
  descriptionHtml,
}) => {
  // hide if nullish
  if (!descriptionHtml || descriptionHtml === '<p></p>') {
    return null;
  }
  return (
    <Popover
      id={id}
      placement="auto-end"
      contents={<SanitizeHtml html={descriptionHtml} />}
      injectA11yProps
    >
      <button
        className="btn btn-link text-black"
        style={{ float: 'right', paddingTop: '5px' }}
        type="button"
      >
        <Icon type="i-circle" />
      </button>
    </Popover>
  );
};
